<template>
  <div class="content-area">
    <hero-bar>
      #{{ id }}
    </hero-bar>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <section v-if="data" class="section is-main-section transfer-details">
      <div class="columns">
        <card-component
          title="Talep Bilgileri"
          :has-button-slot="true"
          icon="transit-transfer"
          class="mr-10 bfy-column w-50"
        >
          <b-field horizontal label="Talep Tarihi" class="nowrap">
            {{ data.service_date | formatDate }}
          </b-field>

          <b-field horizontal label="Talep Türü">
            {{ data.service_type_specification.name }}
          </b-field>

          <b-field horizontal label="Talep Eden Birim">
            {{ data.request_unit_specification.name }}
          </b-field>

          <b-field horizontal label="Talep Eden Ad & Soyad" class="nowrap">
            <span>{{ data.demandant_name }}</span>
          </b-field>

          <b-field horizontal label="Talep Eden Telefon">
            <a :href="'tel:' + data.demandant_phone">{{ data.demandant_phone | phone }}</a>
          </b-field>

          <b-field horizontal label="Açıklama">
            <span>{{ data.description }}</span>
          </b-field>
        </card-component>

        <card-component
          v-if="data.car"
          title="Araç Bilgisi"
          icon="car-info"
          class="mr-10 bfy-column w-40"
        >
          <b-field horizontal label="Plaka">
            {{ data.car.plate }}
          </b-field>

          <b-field horizontal label="Marka">
            {{ data.car.brand }}
          </b-field>

          <b-field horizontal label="Model">
            {{ data.car.model }}
          </b-field>

          <b-field horizontal label="Cinsi">
            {{ data.car.type }}
          </b-field>

          <b-field horizontal label="Koltuk Sayısı">
            {{ data.car.number_of_seats }}
          </b-field>
        </card-component>
      </div>

      <card-component icon="account-card-details">
        <tiles>
          <b-field :label="$t('createdDate')">
            <span>{{ data.created_at | formatDate }}</span>
          </b-field>
        </tiles>
        <tiles>
          <b-field label="Oluşturan Kullanıcı">
            <span>{{ data.user.name }}</span>
          </b-field>
        </tiles>
      </card-component>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
  title: 'Servis Talepleri',
  components: {
    HeroBar: () => import('@/components/HeroBar'),
    CardComponent: () => import('@/components/CardComponent'),
    Tiles: () => import('@/components/Tiles'),
  },
  props: {
    id: {
      type: Number,
      default: function () {
        return parseInt(this.$route.params.id)
      }
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: null,
      isLoading: true,
    }
  },
  computed: {
    ...mapState([
      'bfyHost',
    ]),
    ...mapGetters([
      'authUser',
    ]),
  },
  beforeDestroy () {
    this.$store.commit('setAsideActiveMenuKey', '')
  },
  async mounted () {
    this.loadServiceRecordDetails()
    this.$store.commit('setAsideActiveMenuKey', 'service_records.index')
  },
  methods: {
    loadServiceRecordDetails () {
      this.showSpinner();
      this.$http
        .get(`service-records/${this.id}`)
        .then(({ data }) => {
          this.data = data.data

          this.$nextTick(() => {
            this.hideSpinner()
            this.isLoading = false
          });
      });
    },
    goBack () {
      if (this.isModal) {
        this.$store.commit('boardRefresh', true);
        this.$parent.close();
        return;
      }

      this.$router.push({ name: 'service_records.index' });
    }
  }
}
</script>
